import Sticky from './sticky.vue';

Sticky.install = function(Vue) {
  Vue.component(Sticky.name, Sticky);
};

export default Sticky;
